module.exports = new __parcel__URL__("34076_sq.7e8b275a.jpg").toString();